module.exports = __webpack_public_path__ + "img/cpl.17a3c46.png";